const steps = [
  {
    number: "01",
    title: "Contact & Dispatch",
    description:
      "Call (951) 682-2003 or submit a request. Our dispatchers are available 24/7 and will immediately coordinate the nearest available operator for your situation.",
    icon: "ri-phone-line",
    image:
      "https://public.readdy.ai/ai/img_res/026e48e5bbdd3b5a04c65ba6049629af.jpg",
  },
  {
    number: "02",
    title: "Assessment & Routing",
    description:
      "Our team evaluates your vehicle type, location, and recovery needs to assign the right equipment — flatbed, wheel-lift, landoll, or heavy-duty rig.",
    icon: "ri-map-pin-line",
    image:
      "https://readdy.ai/api/search-image?query=tow%20truck%20driver%20assessing%20broken%20down%20vehicle%20on%20highway%20at%20dusk%2C%20professional%20operator%20inspecting%20car%2C%20road%20flares%2C%20dark%20asphalt%2C%20dramatic%20sky%2C%20cinematic%20photorealistic%20dark%20moody%20background&width=600&height=360&seq=proc02&orientation=landscape",
  },
  {
    number: "03",
    title: "Secure Recovery",
    description:
      "Experienced operators handle your vehicle with professional-grade equipment, ensuring compliant, damage-free towing, transport, or recovery.",
    icon: "ri-shield-check-line",
    image:
      "https://readdy.ai/api/search-image?query=heavy%20duty%20flatbed%20tow%20truck%20securing%20vehicle%20with%20chains%20and%20straps%20at%20night%2C%20professional%20towing%20equipment%2C%20dramatic%20lighting%2C%20dark%20road%20background%2C%20cinematic%20photorealistic%20high%20detail&width=600&height=360&seq=proc03&orientation=landscape",
  },
  {
    number: "04",
    title: "Safe Delivery",
    description:
      "Your vehicle is transported to the designated location — repair shop, impound facility, or delivery address — with full documentation and professional communication throughout.",
    icon: "ri-checkbox-circle-line",
    image:
      "https://readdy.ai/api/search-image?query=flatbed%20tow%20truck%20delivering%20vehicle%20to%20auto%20repair%20shop%20at%20night%2C%20unloading%20car%20safely%2C%20professional%20towing%20service%2C%20dark%20urban%20background%2C%20cinematic%20moody%20lighting%2C%20photorealistic%20high%20detail&width=600&height=360&seq=proc04&orientation=landscape",
  },
];

export default function Process() {
  return (
    <section id="process" className="bg-[#0d0d0f] py-28 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase">How It Works</span>
            <div className="w-8 h-px bg-[#D4AF37]"></div>
          </div>
          <h2
            className="text-white font-black text-4xl md:text-5xl"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Our Recovery Process
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative">
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(100%_-_12px)] w-6 h-px bg-gradient-to-r from-[#D4AF37]/60 to-transparent z-10"></div>
              )}
              <div className="bg-[#1a1a1c] border border-[#2a2a2c] rounded-lg overflow-hidden h-full hover:border-[#D4AF37]/30 transition-colors duration-300 flex flex-col">
                {/* Image */}
                <div className="w-full h-44 overflow-hidden relative shrink-0">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                  {/* Step number overlay */}
                  <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center rounded-full bg-[#D4AF37]">
                    <span
                      className="text-black font-black text-xs"
                      style={{ fontFamily: "'Outfit', sans-serif" }}
                    >
                      {step.number}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${step.icon} text-[#D4AF37] text-xl`}></i>
                    </div>
                    <h3
                      className="text-white font-bold text-base"
                      style={{ fontFamily: "'Outfit', sans-serif" }}
                    >
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-[#888] text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
